import * as Sentry from '@sentry/browser';

// Should be set at compile time through environment variables, but for now lets do this.
let sentryEnvironment = 'production';

if (location.hostname.match(/^acc\.(?:.*?)$/)) {
  sentryEnvironment = 'staging';
}

if (location.hostname.match(/^localhost$/)) {
  sentryEnvironment = 'development';
}

console.log(sentryEnvironment);

if (sentryEnvironment !== 'development') {
  // Do not load on dev, no need, and breaks debugging.
  Sentry.init({
    dsn: 'https://10aacd72802e4db3a94cd5d5d5c2fa83@o477606.ingest.sentry.io/5518943',
    environment: sentryEnvironment,
    ignoreErrors: [
      'undefined is not an object',
      'Cannot read properties of',
    ],
  });
}

// import external dependencies
import '@lottiefiles/lottie-player';

// Polyfills
import 'promise-polyfill/src/polyfill';

// Import everything from autoload

import 'select2';
import 'slick-carousel';
import 'swiped-events';
import 'jquery-zoom';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import archive from './routes/archive';
import singleProduct from './routes/single'; // TODO: Rename the file itself
import shoppingcart from './routes/shoppingcart';
import woocommerceCheckout from './routes/woocommerceCheckout';
import woocommerceOrders from './routes/order';
import woocommerceReturnOrder from './routes/woocommerceReturnOrder';
import woocommerceChangePassword from './routes/changePassword.js';
import woocommerceNewsletter from './routes/newsletter.js';
import woocommerceEditAccount from './routes/editAccountForm.js';
import guestLogin from './routes/guestLogin.js';
import woocommerceCart from './routes/woocommerceCart';
import myAccount from './routes/myAccount';
import register from './routes/register';
import adminJs from './wolkyAdmin';

// import loyaltySpinner from './routes/loyalty';

import './plugins/ws-blob';
import './plugins/ws-carrousel';
import './plugins/ws-header';
import './plugins/ws-menu';
import './plugins/ws-account-menu';
import './plugins/ws-filters';
import './plugins/ws-modal';
import './woof/color';
import 'recaptcha-v3';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  //Archive-product page
  archive,
  //Product detail page
  singleProduct,
  //Main shoppingcart page
  shoppingcart,
  woocommerceCheckout,
  //Order page of customer login
  woocommerceEditAccount,
  woocommerceOrders,
  woocommerceReturnOrder,
  woocommerceChangePassword,
  woocommerceNewsletter,
  register,
  // woocommerceEditAccount,
  adminJs,
  guestLogin,
  myAccount,
  woocommerceCart,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
